import React from 'react';

interface RoleIconProps {
  roleName: string;
  className?: string;
}

const RoleIcon: React.FC<RoleIconProps> = ({ roleName, className = '' }) => {
  const getIconSVG = () => {
    switch (roleName.toLowerCase()) {
      case 'attending':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
            <circle cx="12" cy="12" r="10" strokeWidth="2" fill="currentColor" opacity="0.2"/>
            <path d="M9 12l2 2 4-4" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="12" r="10" strokeWidth="2" fill="none"/>
          </svg>
        );
      case 'tentative':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
            <circle cx="12" cy="12" r="10" strokeWidth="2"/>
            <path d="M12 8v4" strokeWidth="2.5" strokeLinecap="round"/>
            <circle cx="12" cy="16" r="1" fill="currentColor"/>
            <path d="M8 8l8 8M16 8l-8 8" strokeWidth="0.5" opacity="0.3"/>
          </svg>
        );
      case 'not attending':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
            <circle cx="12" cy="12" r="10" strokeWidth="2"/>
            <path d="M8 8l8 8M16 8l-8 8" strokeWidth="2.5" strokeLinecap="round"/>
            <circle cx="12" cy="12" r="10" strokeWidth="2" opacity="0.3" fill="currentColor"/>
          </svg>
        );
      case 'spectator':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <ellipse cx="12" cy="12" rx="11" ry="8" opacity="0.15"/>
            <ellipse cx="12" cy="12" rx="8" ry="6" opacity="0.2"/>
            <circle cx="12" cy="12" r="5" opacity="0.3"/>
            <circle cx="12" cy="12" r="3"/>
            <circle cx="12" cy="12" r="1.5" fill="white" opacity="0.8"/>
          </svg>
        );
      case 'founder':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M12 2l2.5 7.5h8l-6.5 5 2.5 7.5-6.5-5-6.5 5 2.5-7.5-6.5-5h8z"/>
            <path d="M12 5l1.5 4.5h5l-4 3 1.5 4.5-4-3-4 3 1.5-4.5-4-3h5z" opacity="0.4"/>
            <circle cx="12" cy="12" r="2" opacity="0.6"/>
          </svg>
        );
      case 'pilot':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M12 2L8 6H4v4L2 12l2 2v4h4l4 4 4-4h4v-4l2-2-2-2V6h-4z" opacity="0.2"/>
            <path d="M12 4l-3 3H6v3l-2 2 2 2v3h3l3 3 3-3h3v-3l2-2-2-2V7h-3z"/>
            <path d="M12 8v8M8 12h8" strokeWidth="1.5" stroke="currentColor" opacity="0.5"/>
            <circle cx="12" cy="12" r="2"/>
            <path d="M10 6h4M10 18h4M6 10v4M18 10v4" strokeWidth="1" stroke="currentColor"/>
          </svg>
        );
      case 'engineer':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M12 2l-8 8 8 8 8-8z" opacity="0.2"/>
            <circle cx="12" cy="10" r="4" opacity="0.3"/>
            <path d="M4 10h4M16 10h4M12 4v4M12 12v4" strokeWidth="1.5" stroke="currentColor"/>
            <circle cx="12" cy="10" r="6" fill="none" strokeWidth="1.5" stroke="currentColor"/>
            <circle cx="12" cy="10" r="2.5"/>
            <path d="M9 7l6 6M15 7l-6 6" strokeWidth="1" stroke="currentColor" opacity="0.4"/>
          </svg>
        );
      case 'security':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M12 2L4 6v5c0 5 3 9.5 8 11 5-1.5 8-6 8-11V6z" opacity="0.2"/>
            <path d="M12 3L5 6.5v4.5c0 4.5 2.5 8.5 7 10 4.5-1.5 7-5.5 7-10V6.5z" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M9 12l2 2 4-4" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round"/>
            <path d="M12 2v10" strokeWidth="0.5" stroke="currentColor" opacity="0.3"/>
          </svg>
        );
      case 'medic':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <rect x="4" y="4" width="16" height="16" rx="2" opacity="0.2"/>
            <rect x="5" y="5" width="14" height="14" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M12 8v8M8 12h8" strokeWidth="2.5" stroke="currentColor" strokeLinecap="round"/>
            <circle cx="12" cy="12" r="6" opacity="0.1"/>
          </svg>
        );
      case 'fighter escort':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M12 2l-6 6v8l6 6 6-6v-8z" opacity="0.15"/>
            <path d="M12 3l-5 5v7l5 5 5-5v-7z" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M7 7l10 10M17 7L7 17" strokeWidth="2" stroke="currentColor" opacity="0.3"/>
            <circle cx="12" cy="12" r="3" opacity="0.4"/>
            <path d="M12 2v5M12 17v5M2 12h5M17 12h5" strokeWidth="1.5" stroke="currentColor"/>
            <circle cx="12" cy="12" r="1.5"/>
          </svg>
        );
      case 'ground combat unit':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M12 2L6 8v8l6 6 6-6V8z" opacity="0.2"/>
            <path d="M12 3L7 8v7l5 5 5-5V8z" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            <rect x="9" y="9" width="6" height="2" rx="0.5"/>
            <rect x="9" y="12" width="6" height="2" rx="0.5"/>
            <rect x="9" y="15" width="6" height="2" rx="0.5"/>
            <circle cx="12" cy="6" r="1.5"/>
            <path d="M8 8h8M8 11h8M8 14h8" strokeWidth="0.5" stroke="currentColor" opacity="0.3"/>
          </svg>
        );
      case 'hauler':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M20 8h-3V4H4v13h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5z" opacity="0.2"/>
            <path d="M19 9h-2V5H5v11" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            <circle cx="8" cy="18" r="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
            <circle cx="18" cy="18" r="2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
            <rect x="6" y="7" width="9" height="5" rx="1" opacity="0.3"/>
            <path d="M19 9l2 2v4h-2" strokeWidth="1.5" stroke="currentColor" fill="none"/>
          </svg>
        );
      case 'miner':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M12 2l-6 6 6 6 6-6z" opacity="0.25"/>
            <path d="M12 14l-6 6 6-2 6 2z" opacity="0.15"/>
            <path d="M12 3l-5 5 5 5 5-5z" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M9 9l6 6M15 9l-6 6" strokeWidth="1.5" stroke="currentColor"/>
            <circle cx="12" cy="12" r="2" opacity="0.5"/>
            <path d="M12 8v8M8 12h8" strokeWidth="0.5" stroke="currentColor" opacity="0.3"/>
            <circle cx="12" cy="12" r="1"/>
          </svg>
        );
      case 'salvager':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M12 2L6 8l6 6 6-6z" opacity="0.2"/>
            <path d="M12 14l-6 6 6-2 6 2z" opacity="0.15"/>
            <circle cx="12" cy="12" r="8" opacity="0.1"/>
            <path d="M12 4l-5 5 5 5 5-5z" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M9 9l6 6M15 9l-6 6" strokeWidth="2" stroke="currentColor" opacity="0.4"/>
            <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            <circle cx="12" cy="12" r="1.5"/>
            <path d="M12 16l-3 4M12 16l3 4M12 16v4" strokeWidth="1" stroke="currentColor" opacity="0.5"/>
          </svg>
        );
      case 'industrial pilot':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M12 2L8 6H4v4L2 12l2 2v4h4l4 4 4-4h4v-4l2-2-2-2V6h-4z" opacity="0.15"/>
            <rect x="8" y="8" width="8" height="8" rx="1" opacity="0.2"/>
            <path d="M12 5l-2.5 2.5H7v2.5L5 12l2 2v2.5h2.5L12 19l2.5-2.5H17V14l2-2-2-2V7.5h-2.5z" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            <rect x="9" y="10" width="6" height="1.5" rx="0.5"/>
            <rect x="9" y="12.5" width="6" height="1.5" rx="0.5"/>
            <circle cx="12" cy="12" r="1"/>
            <path d="M7 12h2M15 12h2M12 7v2M12 15v2" strokeWidth="1" stroke="currentColor" opacity="0.5"/>
          </svg>
        );
      case 'vehicle operator':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M18 5L17 9H7L6 5H4v14h2v1c0 .55.45 1 1 1s1-.45 1-1v-1h8v1c0 .55.45 1 1 1s1-.45 1-1v-1h2V5z" opacity="0.2"/>
            <path d="M17.5 6l-1 3H7.5l-1-3H5v12" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            <circle cx="8" cy="16" r="1.5" strokeWidth="1.5" stroke="currentColor" fill="none"/>
            <circle cx="16" cy="16" r="1.5" strokeWidth="1.5" stroke="currentColor" fill="none"/>
            <rect x="7" y="10" width="10" height="3" rx="0.5" opacity="0.3"/>
            <path d="M19 9v9M5 9v9" strokeWidth="1.5" stroke="currentColor"/>
          </svg>
        );
      case 'standby':
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <circle cx="12" cy="12" r="10" opacity="0.15"/>
            <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            <circle cx="12" cy="12" r="6" opacity="0.1"/>
            <path d="M12 6v6l4 2" strokeWidth="2" stroke="currentColor" strokeLinecap="round"/>
            <circle cx="12" cy="12" r="1.5"/>
            <path d="M12 3v1M12 20v1M3 12h1M20 12h1M5.6 5.6l.7.7M17.7 17.7l.7.7M5.6 18.4l.7-.7M17.7 6.3l.7-.7" strokeWidth="1" stroke="currentColor" opacity="0.4"/>
          </svg>
        );
      default:
        // Default icon for unknown roles
        return (
          <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        );
    }
  };

  return getIconSVG();
};

export default RoleIcon;
